export const normalizeAttrName = (name:string) => name.replace(/pa_/,"")